.section {
  padding: 7rem 2rem;
  background: var(--color-background);
  color: var(--color-foreground);
}

.container {
  max-width: 74rem;
  margin: 0 auto;
}

.header {
  max-width: 44rem;
  margin-bottom: 3rem;
}

.title {
  margin: 0 0 1rem;
}

@media (max-width: 640px) {
  .section {
    padding: 5rem 1.25rem;
  }
}
